<template>
  <Section>
    <template #header back>
      <div class="mr-auto">
        <strong class="black--text">Card on File</strong>
      </div>
      <v-btn icon x-small color="grey" :to="{ name: 'billing/new_payment_method' }">
        <v-icon small>mdi-square-edit-outline</v-icon>
      </v-btn>

    </template>

    <div class="d-flex align-center" v-if="pro.default_payment_method">
      <div class="d-flex align-center justify-center" style="width: 60px; height: 60px;">
        <CardLogo :brand="pro.default_payment_method.brand" />
      </div>
      <div class="pl-3">
        <div>
          {{ brandWord(pro.default_payment_method.brand) }} ending in {{ pro.default_payment_method.last4 }}
        </div>
        <div>
          Expires: {{ pro.default_payment_method.expires}}
        </div>
      </div>
    </div>
    <div v-else class="py-4 text-center">
      Please add a card on file.
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import CardLogo from '@/components/CardLogo'
  import formatters from '@/lib/formatters'


  export default {
    name: 'PaymentMethodSection',

    props: ['pro'],

    components: { CardLogo, Section },

    methods: {
      ...formatters,
    },
  }
</script>